var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestorMasterclass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.263 6.04388V2.41874C22.263 2.17837 22.1652 1.94786 21.9912 1.7779C21.8172 1.60793 21.5812 1.51245 21.3351 1.51245H2.77842C2.53234 1.51245 2.29635 1.60793 2.12234 1.7779C1.94834 1.94786 1.85059 2.17837 1.85059 2.41874V6.04388H22.263Z",
    fill: "#E27007"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85059 7.85645V20.5444C1.85059 20.7848 1.94834 21.0153 2.12234 21.1853C2.29635 21.3552 2.53234 21.4507 2.77842 21.4507H7.4176V7.85645H1.85059Z",
    fill: "#E27007"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27344 21.4507H21.3353C21.5814 21.4507 21.8174 21.3552 21.9914 21.1853C22.1654 21.0153 22.2631 20.7848 22.2631 20.5444V7.85645H9.27344V21.4507Z",
    fill: "#E27007"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorMasterclass);
export default __webpack_public_path__ + "static/media/investorMasterclass.67f3ac52aa790ad1b9aa72ed592aaf90.svg";
export { ForwardRef as ReactComponent };